import { render, staticRenderFns } from "./forgotPassword.vue?vue&type=template&id=70b14c2a&scoped=true"
import script from "./forgotPassword.vue?vue&type=script&lang=js"
export * from "./forgotPassword.vue?vue&type=script&lang=js"
import style0 from "./forgotPassword.vue?vue&type=style&index=0&id=70b14c2a&prod&lang=scss&scoped=true"
import style1 from "./forgotPassword.vue?vue&type=style&index=1&id=70b14c2a&prod&lang=css"
import style2 from "./forgotPassword.vue?vue&type=style&index=2&id=70b14c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b14c2a",
  null
  
)

export default component.exports